import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import { logsSlice, LogsState, toggleIsChartVisible, toggleIsFiltersPanelOpen } from './logs.slice';

export const logsMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const logsState = api.getState()?.[logsSlice.name];

  if (logsState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    logsMiddlewares[action?.type]?.(logsState, action);
  }

  return result;
};

const logsMiddlewares = {
  [toggleIsFiltersPanelOpen.type]: (state: LogsState) => {
    appStorage.setIsLogsFiltersPanelOpen(state.isFiltersPanelOpen);
  },
  [toggleIsChartVisible.type]: (state: LogsState) => {
    appStorage.setIsLogsChartVisible(state.isChartVisible);
  },
};
